const PAGE_UPDATED = (state, page) => {
  state.single = page
}
const HOMEPAGE_UPDATED = (state, page) => {
  state.homepage = page
}
const POST_UPDATED = (state, page) => {
  state.post = page
}
const POSTS_UPDATED = (state, page) => {
  state.posts = page
}
const PAGE_IS_LOADING_UPDATED = (state, pageIsLoading) => {
  state.pageIsLoading = pageIsLoading
}
const POST_IS_LOADING_UPDATED = (state, postIsLoading) => {
  state.postIsLoading = postIsLoading
}
const POSTS_IS_LOADING_UPDATED = (state, postIsLoading) => {
  state.postsIsLoading = postIsLoading
}
const SET_PAGE_TITLE = (state, pageTitle) => {
  state.pageTitle = pageTitle
}
const SET_PAGE_DESC = (state, pageTitle) => {
  state.pageDesc = pageTitle
}

export {
  PAGE_UPDATED,
  POST_UPDATED,
  POSTS_UPDATED,
  HOMEPAGE_UPDATED,
  PAGE_IS_LOADING_UPDATED,
  POST_IS_LOADING_UPDATED,
  POSTS_IS_LOADING_UPDATED,
  SET_PAGE_TITLE,
  SET_PAGE_DESC
}
